class guideController {
    constructor($sce) {
        "ngInject";
        this.$sce=$sce;
        this.name = 'guide';
        this.cata = [
            {
                title: '账号',
                list: [
                    {
                        question: '使用原本需要实名认证吗?',
                        answer: '对于创作用户，需要通过实名认证才可以使用原本版权认证等系列服务。目的是使版权归属严谨有理，确保版权资产的安全。<br>' +
                        '对于转载用户，获取授权不需要实名认证。<br>' +
                        '实名需提供有效身份证号等，实名认证完成后用户头像处显示“已实名”标签。'
                    },
                    {
                        question: '如何修改账号密码?',
                        answer: '在个人信息的账号处点击“修改密码”，可重新设置登录密码。'
                    },
                    {
                        question: '为什么用户名（笔名）只能修改一次？',
                        answer: '原本提供一次修改用户笔名的机会。原本原创认证DNA标签中包含作者的署名信息，保持稳定的用户名（笔名）能更好证明原创作品的归属，因此原本不建议频繁的更换笔名。'
                    },
                    {
                        question: '原本账号绑定个人微信号后有什么作用 ?',
                        answer: '1.用于提现，当原创作品获得交易收益后，可以直接提现到微信钱包。<br>' +
                        '2.用于接收消息，实时接收转载和交易提醒。'
                    }
                ]
            },
            {
                title: '原本版权认证',
                list: [
                    {
                        question: '什么样的内容可以提交认证？',
                        answer: '原本目前支持文本内容认证与图片内容认证。<br>' +
                        '文本内容指一切具有独创性并能以文本形式复制的智力成果。包括诗歌、文章、小说、论文、剧本等等。<br>' +
                        '图片内容指一切具有独创性并能以图片形式复制的智力成果。包括摄影、绘画、设计、手稿等等。'
                    },
                    {
                        question: '什么是原本认证扩展工具?',
                        answer: '原本认证扩展工具是一套能实现版权认证服务的浏览器插件，目前支持谷歌浏览器、360浏览器、猎豹浏览器、以及QQ浏览器。在原本的官网的“插件”页面上下载并按提示完成安装后，用户可以在微信公众号、简书等平台的内容编辑页面直接进行版权认证。详情请点击 <a target="_blank" href="https://yuanben.io/plugin">https://yuanben.io/plugin</a>'
                    },
                    {
                        question: '什么是授权协议? ',
                        answer: '授权协议是创作者对作品的授权和转载方式的声明，由作者在认证的过程中通过选择或自定义产生。<br>' +
                        '授权协议是组成原本DNA的必要内容。转载者需按照创作者的协议要求进行转载。<br>' +
                        '【原本】支持免费的知识共享许可协议以及付费的商业许可协议两种方式。<br>' +
                        '1.知识共享许可协议（即Creative Commons，简称CC）。是一个非营利组织，也是一种创作的授权方式。知识共享组织设计的这一套协议，意在保留作者相关版权权利的前提下，转载者满足特定转载条件的情况下，自由地复制和传播原创作品。原创用户可以灵活选择作品是否允许被修改、被商用，转载者可以免费获得转载权。了解更多：<a target="_blank" href="https://creativecommons.org/licenses/by-nc-nd/2.5/cn/legalcoden">https://creativecommons.org/licenses/by-nc-nd/2.5/cn/legalcode</a><br>' +
                        '2.商业许可协议。使用商业许可协议，作者将决定是否允许自己的作品被改编以及设置作品单次授权转载的价格。<br>'
                    },
                    {
                        question: '作品认证成功后发给我的邮件有什么作用?',
                        answer: '认证邮件中包含了生成作品数字签名时的密钥。该密钥对应唯一的原本DNA，因此请务必保管好认证邮件，并不要让他人知晓邮件中的密钥。当出现版权纠纷时，该邮件中的密钥及相关认证信息将能够作为作品所有权的证明，帮助用户维护版权利益。'
                    },
                    {
                        question: '认证后的内容在哪里查看和管理？',
                        answer: '认证后的内容可在“我的原创”中进行查看和管理。'
                    },
                    {
                        question: '认证详情包含哪些内容？',
                        answer: '成功认证的作品都能在作品的详情页面查看该内容的“认证详情”。“认证详情”主要包含了：<br>' +
                        '1.认证作品的基本信息。包括：标题、作者、发布时间、原本DNA、原本区块链地址；<br>' +
                        '2.作者对作品的所有权证明与存在证明。包括：完整的原本DNA、文章Hash、签名字符串（此字符串仅作者本人可见）、数字签名、签名公钥。'
                    },
                    {
                        question: '原创发布者可对已完成认证的作品进行授权协议的修改吗？',
                        answer: '【原本】暂时不支持对已认证和发布的作品进行授权协议的修改。'
                    },
                    {
                        question: '认证完成后可以删除吗？删除是永久性的吗？',
                        answer: '在“我的原创”列表和内容详情页中可以进行删除操作。删除的内容不可恢复，且失去原创认证效力。<br>' +
                        '已经被他人成功获取授权的内容将无法删除。'
                    },
                    {
                        question: '什么是DNA验证？',
                        answer: 'DNA验证是原创作者验证自己的原创作品所有权的一种方式。<br>' +
                        '验证DNA的必要条件包括：原本DNA，认证内容时收到的认证邮件中的密钥字段，原创者的账号密钥保护码以及正确的图片验证码。只有当所有验证信息都正确完整且匹配一致时，才能够验证通过，验证通过既表示该内容为作者所有，是有力的所有权归属凭证。'
                    }
                ]
            },
            {
                title: '媒体平台',
                list: [
                    {
                        question: '什么是媒体平台?',
                        answer: '作为创作者，从事创作与发表的平台被称作“媒体平台”。比如微信公众号、微博头条、今日头条、知乎以及简书等都属于媒体平台。<br>'
                    },
                    {
                        question: '原本目前支持一键发布到哪些平台？',
                        answer: '原创认证完成后，可将内容一键发布到多个媒体平台。【原本】目前支持发布到微信公众号、微博头条、今日头条三个媒体平台，绑定媒体平台后，可将已认证的文章或图片一键发到微信公众号素材库或直接发布到头条号及微博头条文章。'
                    },
                    {
                        question: '在原本绑定媒体平台有什么作用?',
                        answer: '1.用于一键发布到媒体平台。绑定媒体平台后，可将在［原本］认证完成的文章或图片一键发到微信公众号素材库或直接发布到头条号及微博头条文章。<br>' +
                        '2.用于一键导入历史文章。绑定微信公众号后，可导入微信公众号历史文章进行批量版权认证。<br>'
                    },
                    {
                        question: '如何绑定和解绑媒体平台?',
                        answer: '点击账户头像下方的“媒体平台”，进入“媒体平台”页面，点击相应图标可进行绑定操作。<br>'
                    },
                    {
                        question: '绑定微信公众号后，如何导入公众号历史文章？',
                        answer: '“媒体平台”的公众号绑定框中点击“导入公众号文章”，可立即导入公众号历史文章进行批量认证。'
                    }
                ]
            },
            {
                title: '版权交易',
                list: [
                    {
                        question: '如何进行版权交易。',
                        answer: '在全网任意地址发现想要转载的内容时，转载方可通过：<br>' +
                        '1.点击文章末尾的［原本］认证信息，跳转至原始文章详情页获取转载授权。<br>' +
                        '2.在［原本］搜索页面，搜索框中输入想要转载的文章或图片携带的“DNA标签”中的8位DNA数字，直接搜索获取目标内容，进入内容详情页面获取转载授权。<br>' +
                        '获取授权操作：<br>' +
                        '进入内容详情页，点击“获取授权”按钮，理解授权协议并同意后，在弹出的窗口中键入真实的转载账号信息，点击“确认”，支付成功后即可获得该内容的单次转载授权（目前支持微信、支付宝及余额支付）。<br>'
                    },
                    {
                        question: '获取授权的过程中为什么需要填写转载方的转载平台账号及相关信息?',
                        answer: '在转载用户获取授权过程中，用户必须填写转载账号类型、账号名称以及账号ID。转载授权信息将记录在不可篡改的区块链网络中，每一次转载授权将生成唯一的转载DNA并作为转载检测结果判断的依据，为避免检测系统的误判，请务必保证填写信息真实有效。<br>'
                    },
                    {
                        question: '购买授权的作品可以被如何使用?',
                        answer: '基于原创者制定的授权协议，转载用户需要遵守原创者的授权要求。同时授权范围仅限网络、报刊杂志的非独占性单次转载。'
                    },
                    {
                        question: '作者如何接收和查看授权转载交易详情?',
                        answer: '用户可在原本网页的消息提醒处收到授权交易信息，在“我的交易”页面可以查看历史的版权交易记录与详情。<br>' +
                        '绑定微信号后可直接通过微信获得授权交易信息提醒。<br>'
                    },
                    {
                        question: '作者如何提现收益？',
                        answer: '在“个人信息”页面里的“提现账号”一栏中，点击“立即绑定”即可绑定用来提现的微信号。绑定成功后，在“我的交易”页面点击“提现”,在弹出的窗口中输入提现金额，即可立即提现到微信钱包。<br>'
                    },
                    {
                        question: '作品经过多次转载后依然能够获取版权收益吗?',
                        answer: '可以。用户发表到媒体平台的文章底部携带该作品的“版权标签”，转载者能通过标签中的DNA码自助获取授权。转载者转载发表的文章底部又会携带“转载DNA”，这些转载标签吸引来新的转载者，他们的授权交易仍然会流入最初的原创者手中。以此类推，无论经过多少手转载，所有获取授权的收益都属于原创者。'
                    }
                ]
            },
            {
                title: '全网转载监测',
                list: [
                    {
                        question: '什么是原本全网转载监测系统？',
                        answer: '原本开发”hawkeye（鹰眼）”全网转载监测系统，可以对用户在[原本]认证的每一篇文章进行全网络转载情况的自动监测，原创作品一旦获得原本认证，[原本]将开启对该原创作品的全网转载监测。'
                    },
                    {
                        question: '原创者如何查看已认证作品的全网转载情况?',
                        answer: '根据全网转载监测结果，[原本]从单篇文章被转载情况、单个主体对同一原创账号的原创内容的转载情况，以及不同时间段的转载情况等方面生成可视化的转载报告，用户可在“转载监测”进行页面查看，了解原创内容的所有转载详情。'
                    },
                    {
                        question: '对于侵权的作品，如何处理？',
                        answer: '原本技术团队结合区块链技术开发出“磐石”电子取证系统，用户通过“磐石”可以快速地对侵权证据做固化保全。<br>' +
                        '原本已对接版权专业律所，可为用户提供全程的维权服务。'
                    }
                ]
            },
            {
                title: '取证管理',
                list: [
                    {
                        question: '什么是电子取证？',
                        answer: '网页电子取证是指通过对网页电子数据的固化保全，将涉嫌违法的网上行为进行证据保存的行为。'
                    },
                    {
                        question: '为什么要取证？',
                        answer: '1.网页电子取证是固化网络转载行为和保存侵权证据的的有力手段之一；<br>' +
                        '2.将每一次转载记录固化保存，能够避免涉嫌侵权的转载信息被修改或删除的情况。<br>'
                    },
                    {
                        question: '如何取证（加入取证，取证管理及下载，打包下载）',
                        answer: '在“转载监测”页面中，每一条监测结果右侧都有一个“取证”按钮，点击“取证”即可将该转载监测结果加入取证列表。<br>' +
                        '在“证据管理”页面，“正在取证”列表显示正在取证的信息及状态，“证据列表”显示已完成取证的内容标题、来源及取证时间，可对列表中的信息进行预览，逐条下载或勾选后进行打包下载。打包下载的内容将集中在一个文件夹中，方便用户做在本地进行管理。<br>'
                    },
                ]
            },
            {
                title: '法律维权',
                list: [
                    {
                        question: '如何申请维权？',
                        answer: '原本与专业律所进行合作，帮助用户对接维权法律服务。用户可联系客服提交维权申请，律所会提出针对的维权方案帮助用户维护版权。'
                    }
                ]
            }
        ]
    }
    showDetail(event){
        let $answer=$(event.currentTarget).next();
        if($answer.hasClass('active')){
            $answer.removeClass('active');
        }else{
            $answer.addClass('active');
        }
    }
}

export default guideController;



// WEBPACK FOOTER //
// ./src/app/components/page/help/guide/guide.controller.js